import { getConfig } from "../_metronic/i18n";
import { ROUTE_DEFAULT as SUBCATEGORIES_ROUTE_DEFAULT } from "../app/modules/Subcategories/utils/ModuleHelpers";
import { roles } from "../index";
import { ROUTE_PREFIX as EP_ROUTE_PREFIX } from "../app/modules/EmyProjects/helpers/RoutingHelpers";
import { ROUTE_PREFIX as ES_ROUTE_PREFIX } from "../app/modules/EmyServices/helpers/RoutingHelpers";
import { ROUTE_PREFIX as EMY_PRODUCT_PRE } from "../app/modules/EmyProducts/helpers/RoutingHelpers";

class AEMenuItem {
  constructor({
    id = "index",
    title,
    route_path = "/",
    svg = "/Design/Target.svg",
    roles = [],
    i18nValues = {},
    i18Descriptor = {},
  }) {
    // this.id = id;
    this.id = id;
    this.title = title;
    this.route_path = route_path;
    this.svg = svg;
    this.children = [];
    this.parent = null;
    this.actions = null;
    this.i18Descriptor = i18Descriptor;
    this.i18nValues = i18nValues;
  }

  // addChild(item: AEMenuItem) {
  addChild(item) {
    item.parent = this;
    this.children.push(item);
    return this;
  }

  hasChildren() {
    return this.children.length > 0;
  }

  /**/
}

export const getRoutes = () => {
  return {
    visitor: "ROLE_VISITOR",
    client: "ROLE_CLIENT",
    provider: "ROLE_PROVIDER",
    super_admin: "ROLE_SUPER_ADMIN",
  };
};

export const allRoles = () => {
  return [roles.visitor, roles.client, roles.provider, roles.super_admin];
};
// const authRoles = ()=> [roles.freelancer, roles.provider, roles.super_admin]

const config = getConfig();

/* TODO improve
 * [ ] recursive
 * */
export const getMenuItemByPathname = (pathname) => {
  let item = [];
  getMenu().forEach((e) => {
    if (e.route_path === pathname) {
      item = e;
    } else {
      e.children.forEach((e2) => {
        if (e2.route_path === pathname) {
          item = e2;
        } else {
          e2.children.forEach((e3) => {
            if (e3.route_path === pathname) {
              item = e3;
            }
          });
        }
      });
    }
  });

  return item;

  // const getItem = (item, part)=>{
  //   console.log(item)
  //   return item.find(e=>e.route_path === `/${part}`)
  // }
  // // parts.forEach(part=>{
  // //   item = menu.find(e=>e.route_path === `/${part}`)
  // // })
  //
  // console.log(/*menu,pathname, */getItem(menu.find(e=>e.route_path === `/${parts[0]}`), parts))
};

export const getMenu = (role = config.role) => {
  let MENU = [];

  const EMY_PROJECTS = new AEMenuItem({
    id: "projects",
    title: "EMY_PROJECTS",
    route_path: EP_ROUTE_PREFIX,
    svg: "/Code/Compiling.svg",
  });
  const EMY_SERVICES = new AEMenuItem({
    id: "services",
    title: "EMY_SERVICES",
    route_path: ES_ROUTE_PREFIX,
    svg: "/Design/PenAndRuller.svg",
  });
  const EMY_PRODUCTS = new AEMenuItem({
    id: "products",
    title: "EMY_PRODUCTS",
    route_path: EMY_PRODUCT_PRE,
    svg: "/Shopping/Box3.svg",
  });
  const DASHBOARD = new AEMenuItem({
    id: "dashboard",
    title: "DASHBOARD",
    svg: "/Design/Layers.svg",
    route_path: "/dashboard",
  });
  const CALENDAR = new AEMenuItem({
    id: "calendar",
    title: "CALENDAR",
    route_path: "/calendar_events",
    svg: "/Design/Select.svg",
  });
  const USERS = new AEMenuItem({
    id: "users",
    title: "USERS",
    svg: "/Communication/Group.svg",
    route_path: "/users",
  });
  const TEAMS = new AEMenuItem({
    id: "teams",
    title: "TEAMS",
    route_path: "/teams",
    svg: "/Communication/Group-chat.svg",
  });
  const GROUPS = new AEMenuItem({
    id: "groups",
    title: "GROUPS",
    route_path: "/groups",
    svg: "/Communication/Safe-chat.svg",
  });
  const PROPOSALS = new AEMenuItem({
    id: "proposals",
    title: "PROPOSALS",
    route_path: "/proposals",
    svg: "/Communication/Chat-check.svg",
  });
  const CONTACTS = new AEMenuItem({
    id: "contacts",
    title: "CONTACTS",
    route_path: "/contacts",
    svg: "/Communication/Adress-book2.svg",
  });
  const CHAT = new AEMenuItem({
    id: "chat_rooms",
    title: "PRIVATE_CHAT",
    route_path: "/chat_rooms",
    svg: "/Communication/Chat-locked.svg",
  });
  const EMY_WALLET = new AEMenuItem({
    id: "wallets",
    title: "WALLETS",
    route_path: "/wallets",
    svg: "/Shopping/Wallet.svg",
  });

  if ([roles.provider, roles.client, roles.super_admin].includes(role)) {
    MENU.push(
      DASHBOARD,
      EMY_PROJECTS,
      EMY_SERVICES,
      EMY_PRODUCTS,
      USERS,
      EMY_WALLET
    );
    if ([roles.provider, roles.super_admin].includes(role)) {
      MENU.push(PROPOSALS);
    }
    if ([roles.super_admin].includes(role)) {
      MENU.push(
        new AEMenuItem({
          id: "categories",
          title: "CATEGORIES",
          svg: "/Text/Menu.svg",
          route_path: SUBCATEGORIES_ROUTE_DEFAULT,
        })
      );
      MENU.push(
        new AEMenuItem({
          id: "Skills",
          title: "SKILLS",
          svg: "/Tools/Compass.svg",
          route_path: "/Skills",
        })
      );
      MENU.push(
        new AEMenuItem({
          id: "locations",
          title: "LOCATIONS",
          svg: "/Map/Marker1.svg",
          route_path: "/locations",
        })
      );
    }

    MENU.push(CALENDAR, TEAMS, GROUPS, CONTACTS, CHAT);
  } else {
    MENU.push(EMY_PROJECTS, EMY_SERVICES, EMY_PRODUCTS);
  }

  return MENU;
};
